import { Palette } from './../palette';
import { KnaufColor } from './../knauf-color';
import { KnaufProjectSets } from './../knauf-project-set';
import { KnaufProject } from './../knauf-project';
import { ProjectService } from './../project.service';
import { ActivatedRoute } from '@angular/router';
import { KnaufPaletteSets } from './../knauf-palette-sets';
import { KnaufPaletteSetService } from './../knauf-palette-set.service';
import { Component, OnInit } from '@angular/core';
import { KnaufPalettes } from '../knauf-palettes.enum';

@Component({
  selector: 'app-choose-palette',
  templateUrl: './choose-palette.component.html',
  styleUrls: ['./choose-palette.component.sass']
})
export class ChoosePaletteComponent implements OnInit {
  title: string = "WYBIERZ JEDNĄ Z PALET KOLORYSTYCZNYCH";
  subtitle: string = "Zastanów się, jaki kolor fasady ma Twój wymarzony dom. Dominują na niej szarości, beże, ciepłe brązy, odcienie żółci i pomarańczy, a może łagodna zieleń lub odcienie niebieskiego? Wybierz paletę, której zestawienia kolorystyczne najbardziej Ci się podobają.";
  KnaufPalettes = KnaufPalettes;
  palettes: KnaufPaletteSets;
  houseType: string;
  selectedPalette: KnaufPalettes = KnaufPalettes.invalid;
  knaufProjectColors: KnaufColor[];
  mobilePalettes: Palette[] = [];
  mobilePaletteColors: KnaufColor[][] = [];
  mobilePaletteSelected: number = 0;
  next: string;

  constructor(private palettesService: KnaufPaletteSetService, private route: ActivatedRoute, private projectService: ProjectService) { }

  ngOnInit() {
    this.houseType = this.route.snapshot.paramMap.get('type');
    this.palettes = this.palettesService.getKnaufPaletteSets();

    this.mobilePalettes.push(this.palettes[KnaufPalettes.MiejskiSzyk]);
    this.mobilePalettes.push(this.palettes[KnaufPalettes.KlasycznaElegancja]);
    this.mobilePalettes.push(this.palettes[KnaufPalettes.SwiatoweInspiracje]);
    this.mobilePalettes.push(this.palettes[KnaufPalettes.WZgodzieZNatura]);
    // this.mobilePalettes.push(this.palettes[KnaufPalettes.TopDesign]);
    this.mobilePaletteColors.push(this.projectService.getLayersColors(KnaufProjectSets[KnaufPalettes.MiejskiSzyk][this.houseType].layers));
    this.mobilePaletteColors.push(this.projectService.getLayersColors(KnaufProjectSets[KnaufPalettes.KlasycznaElegancja][this.houseType].layers));
    this.mobilePaletteColors.push(this.projectService.getLayersColors(KnaufProjectSets[KnaufPalettes.SwiatoweInspiracje][this.houseType].layers));
    this.mobilePaletteColors.push(this.projectService.getLayersColors(KnaufProjectSets[KnaufPalettes.WZgodzieZNatura][this.houseType].layers));
    // this.mobilePaletteColors.push(this.projectService.getLayersColors(KnaufProjectSets[KnaufPalettes.TopDesign][this.houseType].layers));
    this.next = "/compose-color-set/" + this.houseType + '/' + 0;
  }

  onPaletteSelect(palette: KnaufPalettes) {
    if (palette != KnaufPalettes.invalid) {
      this.knaufProjectColors = this.projectService.getLayersColors(KnaufProjectSets[palette][this.houseType].layers);
    }
    this.selectedPalette = palette;
  }

  isInactiveStyle(palette: KnaufPalettes) {
    return this.selectedPalette != KnaufPalettes.invalid && this.selectedPalette != palette;
  }

  onMobilePaletteSelect(i: number) {
    this.next = "/compose-color-set/" + this.houseType + '/' + i;

    this.mobilePaletteSelected = i;
  }
}
